import UserInfo from "../UserInfo";
import * as React from "react";
import { Button, Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { defineMessage, FormattedMessage, MessageDescriptor } from "react-intl";
import { MenuBarContainer, MenuBar } from "./styles";
import { HasPermission } from "../tools";

const MenuBarItem = ({ path, message }: { path: string; message: MessageDescriptor }) => (
    <Button component={RouterLink} to={path} size="small">
        <FormattedMessage {...message} />
    </Button>
);

export default () => {
    return (
        <MenuBarContainer>
            <MenuBar>
                <Box sx={{ flexGrow: 1 }}>
                    <MenuBarItem path="/" message={defineMessage({ id: "home", defaultMessage: "Home" })} />
                    <MenuBarItem
                        path="/meeting/list"
                        message={defineMessage({ id: "meeting.futureList", defaultMessage: "Upcoming meetings" })}
                    />
                    <MenuBarItem
                        path="/past-meeting/list"
                        message={defineMessage({ id: "meeting.pastList", defaultMessage: "Past meeting list" })}
                    />
                    <HasPermission name="create_meeting">
                        <MenuBarItem
                            path="/meeting/create"
                            message={defineMessage({ id: "meeting.create", defaultMessage: "Create meeting" })}
                        />
                    </HasPermission>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", marginRight: ".3em" }}>
                    <UserInfo />
                </Box>
            </MenuBar>
        </MenuBarContainer>
    );
};
